module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "player-overlay-play",
    on: {
      "click": _vm.togglePlay
    }
  }, [(!_vm.isPlaying) ? _c('i', {
    staticClass: "fa fa-play",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ce262e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/player/OverlayPlay.vue
// module id = 196
// module chunks = 1